import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FadeInReveal } from '../../../directives/fade-in-reveal';


@Component({
  selector: 'app-services',
  imports: [
    FadeInReveal,
    RouterLink
  ],
  templateUrl: './services.html',
  styleUrl: './services.less'
})
export class Services {

}
